import { render, staticRenderFns } from "./RegionalAnalytics.vue?vue&type=template&id=6ddf2c29&"
import script from "./RegionalAnalytics.vue?vue&type=script&lang=js&"
export * from "./RegionalAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./RegionalAnalytics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports